import {DropdownGroup, DropdownItem, DropdownSubmenu} from 'platform/components';
import {Icon} from 'platform/foundation';

import {
  SALE_VEHICLE_PHOTO_TYPES_BY_GROUP,
  SaleVehiclePhotoType,
  SaleVehiclePhotoTypeGroupSchema,
} from '@dms/api/settings';
import i18n from '@dms/i18n';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {getSaleVehiclePhotoTypeGroupLabel} from '../utils/getSaleVehiclePhotoTypeGroupLabel';
import {getSaleVehiclePhotoTypeLabel} from '../utils/getSaleVehiclePhotoTypeLabel';

interface PhotoTypeSubmenuProps extends TestIdProps {
  photoType: SaleVehiclePhotoType | Nullish;
  onSelect: (photoType: SaleVehiclePhotoType) => void;
}

/** The "Photo type" context menu entry: every Photo Type, grouped, with the current one marked. */
export function PhotoTypeSubmenu(props: PhotoTypeSubmenuProps) {
  return (
    <DropdownSubmenu
      label={i18n.t('entity.photoGuide.actions.setPhotoType')}
      prefix={<Icon value="image/photo_album" />}
      suffix={<Icon value="navigation/arrow_right" />}
      data-testid={suffixTestId('photoType', props)}
    >
      {SaleVehiclePhotoTypeGroupSchema.options.map((group) => (
        <DropdownGroup key={group} label={getSaleVehiclePhotoTypeGroupLabel(group)}>
          {SALE_VEHICLE_PHOTO_TYPES_BY_GROUP[group].map((photoType) => (
            <DropdownItem
              key={photoType}
              label={getSaleVehiclePhotoTypeLabel(photoType)}
              isActive={photoType === props.photoType}
              onClick={() => props.onSelect(photoType)}
              data-testid={suffixTestId(`photoType-${photoType}`, props)}
            />
          ))}
        </DropdownGroup>
      ))}
    </DropdownSubmenu>
  );
}
